import { __extends } from "tslib";
import { IgrItemwiseStrategyBasedIndicator } from "./igr-itemwise-strategy-based-indicator";
import { MarketFacilitationIndexIndicator } from "./MarketFacilitationIndexIndicator";
/**
 * Represents a IgxDataChartComponent Market Facilitation Index indicator series.
 * The Market Facilitation Index (MFI) indicator is represented by
 * the difference of the high and the low for a bar divided by the volume.
 * Default required members: High, Low, Volume
*
* The Market Facilitation Index (MFI) indicator is represented by the difference of the high and the low for a bar divided by the volume.
*
* Example:
*/
var IgrMarketFacilitationIndexIndicator = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrMarketFacilitationIndexIndicator, _super);
    function IgrMarketFacilitationIndexIndicator(props) {
        return _super.call(this, props) || this;
    }
    IgrMarketFacilitationIndexIndicator.prototype.createImplementation = function () {
        return new MarketFacilitationIndexIndicator();
    };
    Object.defineProperty(IgrMarketFacilitationIndexIndicator.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrMarketFacilitationIndexIndicator.prototype, "defaultDisplayType", {
        /**
         * Gets default display type for the current Financial Indicator
        */
        get: function () {
            return this.i.ts;
        },
        enumerable: false,
        configurable: true
    });
    return IgrMarketFacilitationIndexIndicator;
}(IgrItemwiseStrategyBasedIndicator));
export { IgrMarketFacilitationIndexIndicator };
